import AceEditor from "react-ace";
import "ace-builds/src-noconflict/mode-javascript";
import "ace-builds/src-noconflict/mode-html";
import "ace-builds/src-noconflict/mode-css";
import "ace-builds/src-noconflict/theme-monokai";
import Git1 from '../img/git1.png';
import Git2 from '../img/git2.png';
export const Markdown = () =>{


    return(
    
        <div id="articleContent" className="flex">
               <table>
        <thead><tr><th>Element</th><th>Code</th></tr></thead>
           <tr>
               <td>Paragraphe</td>
               <td>1 saut de ligne</td>
           </tr>
           <tr>
               <td>Gras</td>
               <td>**Très important</td>
           </tr>
           <tr>
               <td>Italique</td>
               <td>*italic*</td>
           </tr>
           <tr>
               <td>Titre</td>
               <td># Titre</td>
           </tr>
           <tr>
               <td>Liste non ordo</td>
               <td>- blzefzefzef<br/>
               - reerervervrev</td>
           </tr>
           <tr>
               <td>Liste ordo</td>
               <td>1.fzefzefezf<br/>
               2. blablalabla</td>
           </tr>
           <tr>
               <td>Bloc de code</td>
               <td>1 tabulation ou 4 espaces</td>
           </tr>
           <tr>
               <td>Code en ligne</td>
               <td>`print`</td>
           </tr>
           <tr>
               <td>Lien</td>
               <td>[lien](https://www.blabla.com)</td>
           </tr>
           <tr>
               <td>img avec lien</td>
               <td>[![N|Solid](https://cldup.com/dTxpPi9lDf.thumb.png)](https://nodesource.com/products/nsolid)</td>
           </tr>
           <tr>
               <td>Bare de separation</td>
               <td>-------- ou *********</td>
           </tr>
           <tr>
               <td>Citation</td>
               <td>></td>
           </tr>
        </table>
      </div>
    )
}
